function toTwoDp(numberOrString) {
    let number = numberOrString
    if (typeof numberOrString === 'string') {
        number = parseFloat(numberOrString)
    }
    return Math.round((number + Number.EPSILON) * 100) / 100
}

export { toTwoDp }
